module.exports = {
    namespace: 'levels',

    da: {
        'rough-diamond': {
            name: 'Rough Diamond',
        },
        'rising-star': {
            name: 'Rising Star',
        },
        mastermind: {
            name: 'Mastermind',
        },
    },

    en: {
        'rough-diamond': {
            name: 'Rough Diamond',
        },
        'rising-star': {
            name: 'Rising Star',
        },
        mastermind: {
            name: 'Mastermind',
        },
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/levels/locales/index.js